var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-layout", { attrs: { row: "" } }),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-card",
            {
              staticClass: "mx-auto",
              attrs: { "max-width": "344", outlined: "" }
            },
            [
              _c(
                "v-list-item",
                { attrs: { "three-line": "" } },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("div", { staticClass: "overline mb-4" }, [
                        _vm._v("DANGEROUS")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-item-title",
                        { staticClass: "headline mb-1" },
                        [_vm._v("Find Missing Tech Props")]
                      ),
                      _vm._v(" "),
                      _c("v-list-item-subtitle", [
                        _vm._v(
                          "Find who is missing tech props and in which skill."
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary--text filter-item",
                      attrs: { outlined: "" },
                      on: {
                        click: function($event) {
                          return _vm.findMissingTech()
                        }
                      }
                    },
                    [_vm._v("FIND")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm10: "", "offset-sm1": "" } },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        color: "info",
                        icon: "warning",
                        dismissible: ""
                      },
                      model: {
                        value: _vm.isDuplicateEmail,
                        callback: function($$v) {
                          _vm.isDuplicateEmail = $$v
                        },
                        expression: "isDuplicateEmail"
                      }
                    },
                    [
                      _c(
                        "span",
                        { staticStyle: { color: "red", "font-size": "1.3em" } },
                        [
                          _vm._v(
                            "Woah, slow down there, Slappy. That email is already in the list."
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm2: "", "offset-sm1": "", md2: "", lg1: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green", fab: "", small: "" },
                      on: {
                        click: function($event) {
                          return _vm.addAdministrator(_vm.administratorsRef)
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "white--text" }, [
                        _vm._v("add")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs8: "", lg9: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "E-mail",
                      rules: [_vm.rules.required, _vm.rules.email]
                    },
                    model: {
                      value: _vm.email,
                      callback: function($$v) {
                        _vm.email = $$v
                      },
                      expression: "email"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm10: "", "offset-sm1": "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { staticClass: "primary white--text" },
                    [
                      _c("v-toolbar-title", [_vm._v("Administrators")]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    _vm._l(_vm.administrators, function(administrator) {
                      return _c(
                        "v-list-item",
                        { key: administrator[".key"], attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", {
                                domProps: {
                                  textContent: _vm._s(administrator.email)
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-avatar",
                            [
                              _c(
                                "v-dialog",
                                {
                                  attrs: { persistent: "" },
                                  model: {
                                    value: _vm.deleteDialog,
                                    callback: function($$v) {
                                      _vm.deleteDialog = $$v
                                    },
                                    expression: "deleteDialog"
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        slot: "activator",
                                        color: "error",
                                        fab: "",
                                        small: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.setAdministratorKey(
                                            administrator[".key"]
                                          )
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [_c("v-icon", [_vm._v("delete")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-title",
                                        { staticClass: "headline" },
                                        [_vm._v("Remove Administrator?")]
                                      ),
                                      _vm._v(" "),
                                      _c("v-card-text", [
                                        _vm._v(
                                          "Are you sure you want to remove " +
                                            _vm._s(
                                              _vm.selectedAdministrator.email
                                            ) +
                                            " from the list of Administrators?"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-actions",
                                        [
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "darken-1",
                                                flat: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.deleteDialog = false
                                                }
                                              }
                                            },
                                            [_vm._v("Cancel")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "darken-1",
                                                flat: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.removeAdministrator(
                                                    _vm.selectedAdministrator
                                                      .key
                                                  )
                                                  _vm.deleteDialog = false
                                                }
                                              }
                                            },
                                            [_vm._v("Remove")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-538ddd6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-538ddd6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Roles/Roles.vue
// module id = 5v62
// module chunks = 1